import React, { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom'; 
import './App.css'; 
import UseLang from './components/hook/UseLang';
// Lazy imports
const HomePage = React.lazy(() => import('./pages/homepage/content/HomePage'));
const NoMatch = React.lazy(() => import('./pages/no-match/NoMatch'));
const Programme = React.lazy(() => import('./pages/programme/agenda/programme/Programme'));
const HotelsAndTravel = React.lazy(() => import('./pages/hotels-travel/HotelsAndTravel/HotelsAndTravel'));
const Sponsorship = React.lazy(() => import('./pages/sponsorship/event-sponsorships/Sponsorship'));
const HowToParticipate = React.lazy(() => import('./pages/participate/HowToParticipate/HowToParticipate'));
const Registration = React.lazy(() => import('./pages/registration/registration/Registration'));
const Multimedia = React.lazy(() => import('./pages/multimedia/Multimedia/Multimedia'));
const StandPage = React.lazy(() => import('./pages/stand/StandPage'));
const PhotosPage = React.lazy(() => import('./pages/multimedia/Photos/PhotosPage'));
const IndexRedirect = React.lazy(() => import('./components/routing/IndexRedirect'));

function App() { 
    const slugs = {
        es: {
            participate: 'como-participar',
            programme: 'programa',
            hotels: 'hoteles-y-viaje',
            sponsorship: 'patrocinios',
            media: 'media',
            registration: 'registro',
            multimedia: 'media',
            streaming: 'streaming',
            stand: 'stand',
            photos: 'fotos'
        },
        en: {
            participate: 'how-to-participate',
            programme: 'programme',
            hotels: 'hotels-and-travel',
            sponsorship: 'sponsorship',
            media: 'media',
            registration: 'registration',
            multimedia: 'media',
            streaming: 'streaming',
            stand: 'stand',
            photos: 'photos'
        },
        'pt-br': {
            participate: 'como-participar',
            programme: 'programa',
            hotels: 'hoteis-e-viagem',
            sponsorship: 'patrocinios',
            media: 'media',
            registration: 'inscricao',
            multimedia: 'media',
            streaming: 'streaming',
            stand: 'stand',
            photos: 'fotos'
        }
    };
  
    return ( 
        <Suspense fallback={<div></div>}> 
            <Routes>   
                <Route 
                    index
                    element={<IndexRedirect />} 
                />
                {Object.entries(slugs).map(([lang, routes]) => (
                    <React.Fragment key={lang}> 
                        <Route 
                            path={lang} 
                            element={<HomePage lang={lang} />} 
                        />
                        <Route path={`/${lang}/${routes.hotels}/*`} element={<HotelsAndTravel lang={lang} />} />
                        <Route path={`/${lang}/${routes.sponsorship}/*`} element={<Sponsorship lang={lang} />} /> 
                        <Route path={`/${lang}/${routes.participate}/*`} element={<HowToParticipate lang={lang} />} /> 
                        <Route path={`/${lang}/${routes.registration}/*`} element={<Registration lang={lang} />} />   
                        <Route path={`/${lang}/${routes.multimedia}/*`} element={<Multimedia lang={lang} />} />   
                        <Route path={`/${lang}/${routes.streaming}`} element={<Multimedia lang={lang} />} /> 
                        <Route path={`/${lang}/${routes.stand}`} element={<StandPage lang={lang} />} />
                        <Route path={`/${lang}/${routes.photos}`} element={<PhotosPage lang={lang} />} />
                        <Route path="/streaming" element={<><UseLang es><Navigate to="/es/streaming" replace /></UseLang> <UseLang en> <Navigate to="/en/streaming" replace /></UseLang> <UseLang pt_br> <Navigate to="/pt-br/streaming" replace /></UseLang></>} /> 
                        <Route path="/stand" element={<><UseLang es><Navigate to="/es/stand" replace /></UseLang> <UseLang en> <Navigate to="/en/stand" replace /></UseLang> <UseLang pt_br> <Navigate to="/pt-br/stand" replace /></UseLang></>} />
                        <Route path={`/${lang}/${routes.programme}/*`} element={<Programme lang={lang} />} /> 
                    </React.Fragment>
                ))}   
                <Route path="*" element={<NoMatch />} />
            </Routes> 
        </Suspense>
    );
}

export default App;